export const addLeadingZero = number => (number < 10 ? '0' + number : number);

export const adaptBillNumberFormat = ticket_bill_number =>
  ('' + ticket_bill_number).length < 6 ? `AFV/21/000${ticket_bill_number}FB` : ticket_bill_number;
